import { useTranslation } from 'react-i18next';
import {
  findTeamStatusLabel,
  paymentStatuses,
  cardStatuses,
} from '@utils/statuses';

function getStatusLabel(data, type) {
  if (type === 'payments') return paymentStatuses[data];
  if (type === 'cards') return cardStatuses[data?.status];
  if (type === 'team') return findTeamStatusLabel(data); // data is object
  return data;
}

export default function Status({ data, type }) {
  const { t } = useTranslation();
  const statusLabel = getStatusLabel(data, type);

  return (
    <p className={`status status--${statusLabel}`}>
      <span>{t(statusLabel)}</span>
    </p>
  );
}
